import { useState } from "react";
import '../styles/faq.css';

const FAQSection = () => {
  const faqs = [
    { q: "Is ZamWheelz really free?", a: "Yes. Downloading the app, creating an account, browsing vehicles and chatting with sellers is 100% free." },
    { q: "How does verification work?", a: "Sellers submit their NRC and a selfie. Dealers also submit business registration documents. Our team reviews and approves within hours." },
    { q: "Can I use ZamWheelz without a smartphone?", a: "ZamWheelz is a mobile-first platform available on iOS and Android. A smartphone with internet access is required." },
    { q: "What cities does ZamWheelz cover?", a: "We're active across Zambia including Lusaka, Ndola, Kitwe, Livingstone, Kabwe and more." },
    { q: 'How do I upgrade from Buyer to Seller?', a: 'Open the app, go to your Profile, tap "Become a Seller", complete the KYC steps, and start listing once approved.' },
    { q: "Is my personal information safe?", a: "Absolutely. We use bank-level encryption, and your phone number is never shared with other users." },
  ];

  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="faq" id="faq">
      <div className="container">
        <div className="faq-grid">
          <div className="faq-left animate-on-scroll animate-slide-left">
            <span className="section-tag">❓ FAQ</span>
            <h2 className="section-title" style={{ textAlign: "left" }}>Got Questions?</h2>
            <p className="section-desc" style={{ textAlign: "left" }}>
              Everything you need to know about ZamWheelz. Can't find an answer? Contact our support team.
            </p>
          </div>
          <div className="faq-right animate-on-scroll animate-slide-right">
            {faqs.map((f, i) => (
              <div className={`faq-item ${openIndex === i ? "active" : ""}`} key={i}>
                <button className="faq-question" onClick={() => setOpenIndex(openIndex === i ? null : i)}>
                  {f.q}
                  <span className="faq-chevron">▼</span>
                </button>
                <div className="faq-answer">
                  <p>{f.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;